<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Preventive Animal Health and Vaccination
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <subsection title="Lepto Products Purchased" :step-name="stepName" subsection="lepto_products_purchased">
        <div v-if="model.CHARTS.lepto_purchases.length > 0">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Purchase Date</th>
                <th>Farm</th>
                <th>Stock Code - Name</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lp, index) in model.CHARTS.lepto_purchases" :key="'lepto_' + index">
                <td class="text-left">{{ lp['Purchase Date'] }}</td>
                <td class="text-left">{{ lp['Farm'] }}</td>
                <td class="text-left">{{ lp['Stock Code - Name'] }}</td>
                <td class="text-left">{{ lp['Quantity'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <p>No Results</p>
        </div>
      </subsection>

      <subsection
        :title="`Salmonella Vaccination ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-salmonella_vac`"
        v-for="farm in model.FARMS"
        :key="'salmo_v_' + farm.id"
      >
        <dl class="dl-horizontal">
          <dt>Salmonella Vaccination?</dt>
          <dd>{{ model[`farm_${farm.id}-wants_salmonella_vaccine`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>First time user</dt>
          <dd>{{ model[`farm_${farm.id}-is_first_time_salmonella_vax_user`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Continuous user</dt>
          <dd>{{ model[`farm_${farm.id}-is_continuous_salmonella_vax_user`] || '-' }}</dd>
        </dl>
      </subsection>

      <subsection
        :title="`Scour Vaccination ${farm.farm_label}`"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-scour_vac`"
        v-for="farm in model.FARMS"
        :key="'scour_v_' + farm.id"
      >
        <report-comment
          title="Scour Vaccine Clinical Notes"
          :field_name="`farm_${farm.id}-heading_scour_vaccination`"
          :model="model.COMMENTS"
          :heading="false"
        >
        </report-comment>

        <dl class="dl-horizontal">
          <dt>Date required</dt>
          <dd>{{ model[`farm_${farm.id}-scour_vaccine_req_date`] || '-' }}</dd>
        </dl>

        <dl class="dl-horizontal">
          <dt>Order notes to Retail</dt>
          <dd>{{ model[`farm_${farm.id}-scour_vaccine_product_and_doses_req`] || '-' }}</dd>
        </dl>
      </subsection>

      <subsection title="Scour Vaccinations" class="step-section">
        <dl class="dl-horizontal">
          <dt>Interested in Agvance transition salts?</dt>
          <dd>{{ model.wants_agvance_transition_salts || '-' }}</dd>
        </dl>
        <report-comment field_name="wants_agvance_transition_salts" :model="model.COMMENTS" :heading="false">
        </report-comment>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'PreventiveHealthAndVacination',
  mixins: [mixin],
}
</script>
